export default "__VITE_ASSET__1500c668__"